module.exports = __webpack_public_path__ + "static/media/news-details-ad.a9765e94.png";